import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineRentListApi extends BaseClient {
  public getMachineRentList (data: any) {
    const path = '/v1/machine-rents'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    params.append('page', data.page)

    if (data.word !== '') {
      params.append('word', data.word)
    }
    if (data.order_name !== '') {
      params.append('order_name', data.order_name)
    }
    if (data.sort === false) {
      params.append('sort', 'desc')
    } else {
      params.append('sort', 'asc')
    }
    if (data.step !== undefined && data.step !== null) {
      params.append('step', data.step)
    }
    if (data.rent_status !== undefined && data.rent_status !== null) {
      params.append('rent_status', data.rent_status)
    }
    if (data.group_id !== undefined && data.group_id !== null) {
      params.append('group_id', data.group_id)
    }
    if (data.machine_id !== undefined && data.machine_id !== null) {
      params.append('machine_id', data.machine_id)
    }
    if (data.machine_type !== undefined && data.machine_type !== null) {
      params.append('machine_type', data.machine_type)
    }
    if (data.created_at !== undefined && data.created_at !== null) {
      params.append('created_at', data.created_at)
    }
    if (data.created_by !== undefined && data.created_by !== null) {
      params.append('created_by', data.created_by)
      params.append('created_type', data.created_type)
    }
    if (data.rent_start_date !== undefined && data.rent_start_date !== null) {
      params.append('rent_start_date', data.rent_start_date)
    }
    if (data.rent_end_date !== undefined && data.rent_end_date !== null) {
      params.append('rent_end_date', data.rent_end_date)
    }
    if (data.use_start_date !== undefined && data.use_start_date !== null) {
      params.append('use_start_date', data.use_start_date)
    }
    if (data.use_end_date !== undefined && data.use_end_date !== null) {
      params.append('use_end_date', data.use_end_date)
    }
    if (data.limit !== undefined && data.limit !== null) {
      params.append('limit', data.limit)
    }
    if (data.field_id !== undefined && data.field_id !== null) {
      params.append('field_id', data.field_id)
    }
    if (data.role_no !== undefined && data.role_no !== null) {
      params.append('role_no', data.role_no)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new MachineRentListApi()
